import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_URL } from '../../api/api';

const API_BANK_URL = `${API_URL}/bank-account`;

const AdminBankAccountLayer = () => {
    const [formData, setFormData] = useState({
        bankName: '',
        accountNumber: '',
        ifscCode: '',
        accountHolderName: '',
    });

    const token = localStorage.getItem('token');

    // ⬇️ Fetch existing bank account details
    useEffect(() => {
        if (!token) return;

        axios
            .get(API_BANK_URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                if (res.data) {
                    setFormData({
                        bankName: res.data.bank_name || '',
                        accountNumber: res.data.account_number || '',
                        ifscCode: res.data.ifsc_code || '',
                        accountHolderName: res.data.account_holder_name || '',
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching bank account:', error);
            });
    }, [token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!token) {
            return Swal.fire('Unauthorized', 'Please log in first.', 'warning');
        }

        try {
            const payload = {
                bank_name: formData.bankName,
                account_number: formData.accountNumber,
                ifsc_code: formData.ifscCode,
                account_holder_name: formData.accountHolderName,
            };

            await axios.post(API_BANK_URL, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            Swal.fire('Success', 'Bank account saved successfully', 'success');
        } catch (error) {
            console.error(error);
            const message = error.response?.data?.message || 'Failed to add bank account';
            Swal.fire('Error', message, 'error');
        }
    };

    return (
        <div className="row gy-4">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h5 className="card-title mb-0">Add / Update Bank Account</h5>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Bank Name</label>
                                <input
                                    type="text"
                                    name="bankName"
                                    className="form-control"
                                    value={formData.bankName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Account Number</label>
                                <input
                                    type="text"
                                    name="accountNumber"
                                    className="form-control"
                                    value={formData.accountNumber}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">IFSC Code</label>
                                <input
                                    type="text"
                                    name="ifscCode"
                                    className="form-control"
                                    value={formData.ifscCode}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Account Holder Name</label>
                                <input
                                    type="text"
                                    name="accountHolderName"
                                    className="form-control"
                                    value={formData.accountHolderName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary">Save</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminBankAccountLayer;
